import { useState } from "react";
import { Loader2, Plus } from "lucide-react";
import { toast } from "sonner";
import { api, formatError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

export const COL_TYPES = [["text", "Text"], ["number", "Number"], ["date", "Date"], ["boolean", "Yes / No"]];

export default function AddColumnForm({ dbId, table, onAdded, testPrefix = "add-col" }) {
  const [name, setName] = useState("");
  const [type, setType] = useState("text");
  const [busy, setBusy] = useState(false);
  const add = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const { data } = await api.post(`/databases/${dbId}/tables/${encodeURIComponent(table)}/columns`, { name, type });
      toast.success(`Added column "${name.trim()}"`);
      setName("");
      setType("text");
      onAdded(data);
    } catch (err) { toast.error(formatError(err)); }
    setBusy(false);
  };
  return (
    <form onSubmit={add} className="flex flex-wrap items-center gap-2" data-testid={`${testPrefix}-form`}>
      <Input className="h-8 flex-1 min-w-[160px]" placeholder="New column name, e.g. Notes" maxLength={64} value={name} onChange={(e) => setName(e.target.value)} data-testid={`${testPrefix}-name`} />
      <Select value={type} onValueChange={setType}>
        <SelectTrigger className="h-8 w-32" data-testid={`${testPrefix}-type`}><SelectValue /></SelectTrigger>
        <SelectContent className="bg-card">{COL_TYPES.map(([v, l]) => <SelectItem key={v} value={v} data-testid={`${testPrefix}-type-${v}`}>{l}</SelectItem>)}</SelectContent>
      </Select>
      <Button size="sm" type="submit" disabled={busy || !name.trim()} data-testid={`${testPrefix}-submit`}>{busy ? <Loader2 size={13} className="animate-spin" /> : <Plus size={13} />} Add column</Button>
    </form>
  );
}
